import React, { useEffect, useRef } from "react";
import {
  Modal,
  Table,
  Button,
  Row,
  Col,
  FormControl,
  FormGroup,
  ControlLabel,
  Tab,
} from "react-bootstrap";
import Select from "react-select";
import "./MedicineWiseBatchersSelect.css";

const RaisePo = ({
  getSupplierOption,
  medicineName,
  show,
  onHide,
  onSubmit,
  enterPoRaiseQty,
  setEnterPoRaiseQty,
  isSubmitting,
}) => {
  const qtyInputRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(() => {
      if (
        qtyInputRef.current &&
        typeof qtyInputRef.current.focus === "function"
      ) {
        qtyInputRef.current.focus();
      }
    }, 120);

    return () => clearTimeout(timer);
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} bsSize="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Raise Po</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table>
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "16px",
                  width: "30%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Medicine Name
              </th>
              <th
                style={{
                  fontSize: "16px",
                  width: "30%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <FormControl
                  type="text"
                  name="Medicine"
                  placeholder="Medicine Name"
                  value={medicineName || ""}
                  readOnly
                />
              </td>
              <td>
                <FormControl
                  placeholder="Qty"
                  type="number"
                  name="qty"
                  min="1"
                  required
                  inputRef={(el) => {
                    qtyInputRef.current = el;
                  }}
                  value={enterPoRaiseQty}
                  disabled={!!isSubmitting}
                  onChange={(e) => setEnterPoRaiseQty(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-danger" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success"
          onClick={onSubmit}
          disabled={!!isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RaisePo;
